import { Controller } from "@hotwired/stimulus"
import { i18n } from "../lib/i18n"

export default class extends Controller {
  static targets = ["bedSelection", "bedOptions", "bedInfo"]
  
  declare readonly bedSelectionTarget: HTMLElement
  declare readonly bedOptionsTarget: HTMLElement
  declare readonly bedInfoTarget: HTMLElement
  toggleBedAssignment(event: Event) {
    const checkbox = event.target as HTMLInputElement

    if (checkbox.checked) {
      this.showBedSelection()
    } else {
      this.hideBedSelection()
    }
  }

  async roomChanged(event: Event) {
    const select = event.target as HTMLSelectElement
    const roomId = select.value

    if (roomId) {
      await this.loadBedsForRoom(roomId)
      this.showBedOptions()
    } else {
      this.hideBedOptions()
    }
  }

  private async loadBedsForRoom(roomId: string) {
    try {
      // Get facility ID from the form's data attribute
      const form = this.element.closest('form')
      const facilityId = form?.dataset.facilityId

      console.log('Loading beds for room:', roomId, 'facility:', facilityId)

      if (!facilityId) {
        throw new Error('Facility ID not found')
      }

      const url = `/shelter/facilities/${facilityId}/rooms/${roomId}/beds.json`
      console.log('Fetching URL:', url)

      const response = await fetch(url)
      console.log('Response status:', response.status, response.statusText)

      if (response.ok) {
        const beds = await response.json()
        console.log('Received beds:', beds)

        const bedSelect = this.bedOptionsTarget.querySelector('select') as HTMLSelectElement
        bedSelect.innerHTML = `<option value="">${i18n.t('check_in_form.select_a_bed')}</option>`

        const availableBeds = beds.filter((bed: any) => bed.available)
        console.log('Available beds:', availableBeds)

        availableBeds.forEach((bed: any) => {
          const option = document.createElement('option')
          option.value = bed.id
          option.textContent = `${bed.name}${bed.bed_type ? ` (${bed.bed_type})` : ''}`
          bedSelect.appendChild(option)
        })

        // Update bed info
        const totalCount = beds.length
        const availableCount = availableBeds.length

        this.bedInfoTarget.innerHTML = `
          <div class="flex items-center gap-2">
            <span class="badge badge-success">${i18n.t('check_in_form.available_beds', { count: availableCount })}</span>
            <span class="badge badge-outline">${i18n.t('check_in_form.total_beds', { count: totalCount })}</span>
          </div>
        `
      } else {
        const errorText = await response.text()
        console.error('Error response:', response.status, errorText)
        this.bedInfoTarget.innerHTML = `<div class="text-red-600 text-sm">${i18n.t('check_in_form.error_loading_beds_with_status', { status: response.status })}</div>`
      }
    } catch (error) {
      console.error('Error loading beds:', error)
      this.bedInfoTarget.innerHTML = `<div class="text-red-600 text-sm">${i18n.t('check_in_form.error_loading_beds')}</div>`
    }
  }

  private showBedSelection() {
    this.bedSelectionTarget.classList.remove('hidden')
  }

  private hideBedSelection() {
    this.bedSelectionTarget.classList.add('hidden')
    this.hideBedOptions()
  }

  private showBedOptions() {
    this.bedOptionsTarget.classList.remove('hidden')
  }

  private hideBedOptions() {
    this.bedOptionsTarget.classList.add('hidden')
    this.bedInfoTarget.innerHTML = ''
  }
}
